
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

/**
 * Triggers a re-analysis of a candidate's CV
 * @param candidateId - ID of the candidate
 * @param cvUrl - URL to the CV file (not used in modern implementation)
 * @param notes - Optional additional notes for analysis (not used in modern implementation)
 */
export const triggerReanalysis = async (
    candidateId: string,
    cvUrl: string | null,
    notes: string = ""
): Promise<void> => {
    //console.log("🔥🔥🔥 REANALYZE FUNCTION CALLED 🔥🔥🔥", { candidateId, cvUrl, notes });
    
    try {
        
        // Use the modern AI processing queue system
        const { data, error } = await supabase.functions.invoke('ai-processing?command=push-new-analysis', {
            method: 'POST',
            body: {
                entityId: candidateId,
                entityType: "candidate",
                analysisType: 'analyse-resume-including-science',
                actionOnComplete: "update-candidate",
            }
        });

        if (error) {
            console.error("[triggerReanalysis] Error triggering AI analysis:", error);
            throw new Error(`Failed to trigger AI analysis: ${error.message}`);
        }

        //console.log("[triggerReanalysis] AI analysis queued successfully:", data);

        toast({
            title: "AI Analysis Queued",
            description: "Candidate profile analysis has been queued and will be processed shortly",
        });
    } catch (error) {
        console.error("[triggerReanalysis] Error during re-analysis:", error);
        toast({
            title: "AI Analysis Failed",
            description: `Could not trigger analysis: ${error instanceof Error ? error.message : 'Unknown error'}`,
            variant: "destructive",
        });
    }
};
